import styled from "styled-components";

export const DashboardContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background-color: #0c0d15;
  position: relative;
`;

export const TopBarContainer = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 12px;
  position: absolute;
  right: 40px;
  top: 15px;
  z-index: 1;
`;

// export const DashboardContainer = styled.div`
//   display: flex;
//   width: 100vw;
//   height: 100vh;
//   position: relative;
// `;

// export const RadarContainer = styled.div<{ sidebarWidth: number }>`
//   flex: 1;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   padding-left: ${({ sidebarWidth }) => sidebarWidth}px;
//   transition: padding-left 0.3s ease;
// `;
